import styled from 'styled-components'

export const Content = styled.section`
  display: flex;
  justify-content: space-between;
`
